import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";
import { slugifyCategory } from "../lib/links";
import type { TaxonomyDoc, TaxonomyEntry } from "../sources/taxonomy";
import { CategoryDetail } from "./CategoryDetail";

export function CategoriesTab({
  tax,
  taxError,
  openCats,
  toggleCat,
}: {
  tax: TaxonomyDoc | null;
  taxError: string | null;
  openCats: Set<string>;
  toggleCat: (slug: string) => void;
}) {
  if (taxError) return <div className="coming-soon">Couldn't load taxonomy: {taxError}</div>;
  if (!tax) return <div className="coming-soon">Loading taxonomy…</div>;

  // Pre-bucket conditions by category for fast lookup at render time.
  const byCategory = new Map<string, TaxonomyEntry[]>();
  for (const c of tax.conditions) {
    const list = byCategory.get(c.category) ?? [];
    list.push(c);
    byCategory.set(c.category, list);
  }
  for (const list of byCategory.values()) {
    list.sort((a, b) => a.code.localeCompare(b.code));
  }

  return (
    <div className="card no-pad">
      <table className="roster condition-table">
        <thead>
          <tr>
            <th aria-label="expand" />
            <th>Code</th>
            <th>Category</th>
            <th>Conditions</th>
          </tr>
        </thead>
        <tbody>
          {tax.categories.map((c) => {
            const slug = slugifyCategory(c.name);
            const isOpen = openCats.has(slug);
            const conds = byCategory.get(c.name) ?? [];
            return (
              <Fragment key={slug}>
                <tr
                  id={`cat-${slug}`}
                  className={`condition-row ${isOpen ? "expanded" : ""}`}
                  onClick={() => toggleCat(slug)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") toggleCat(slug);
                  }}
                  tabIndex={0}
                >
                  <td className="chev-cell">
                    <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} fixedWidth />
                  </td>
                  <td className="mono">{c.code}</td>
                  <td>{c.name}</td>
                  <td className="mono">{conds.length}</td>
                </tr>
                {isOpen ? (
                  <tr className="condition-detail-row">
                    <td colSpan={4}>
                      <CategoryDetail category={c} conditions={conds} />
                    </td>
                  </tr>
                ) : null}
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
